import React, { useState } from "react";
import FormButtom from "../../../../../components/common/forms/FormButtom";
import FormPayment from "../../../../../components/common/forms/FormPayment";
import FormBranch from "../../../../../components/common/forms/FormBranch";
import { upload_document, upload_document_v2 } from "./AnualReturn";
import { useForm } from "react-hook-form";
import Documents from "../../../../../components/common/forms/Documents";
import { v4 as uuidv4 } from "uuid";
import axios from "axios";
import BusinessSearchNDetails from "../../../../../components/common/forms/BusinessSearchNDetails";
import api, { url } from "../../../../../api/api";
import { toast } from "react-toastify";
import NewFormPayment from "../../../../../components/common/forms/NewFormPayment";

const OldAnnualForm = () => {
  const { register, handleSubmit } = useForm();
  const [docsOutput, setDocsOutput] = useState([]);
  const [cmpId, setCmpId] = useState(null);
  const [fieldChange, setFieldChange] = useState(true)
  const [uploadProof, setUploadProof] = useState('')

  const handleClick = (data) => {
    // data.share_holders = shareHolders
    data.documents = docsOutput;
    data.company = cmpId
    data.amendment_type = "annual_return_update";
    // console.log(data);

    const user = JSON.parse(localStorage.getItem("user"));


    api.post('services/company/amendments/', data)
      .then((response) => {
        toast.success("Data Registered Successfully")


        // let transactions = {
        //   // payment_mode: "e_wallet",
        //   amount: 2500,
        //   service_object_id: response.data.service_object_id,
        //   created_by: response.data.service_object_id,
        //   service_object_content_type: response.data.service_content_type_id,
        //   payment_proof : uploadProof,
        //   company : cmpId,
        //   transaction_type: "credit"

        // };


        // api
        // .post("/transactions/", transactions)
        // .then((response) => {
        //   toast.success("Data Registered 2 Successfully.");
        // })
        // .catch((error) => {
        //   toast.error("Error in Transaction");
        // });

      })
      .catch((error) => {
        // console.log("error", error);
        toast.error("Something went wrong")
      });
  };

  let data = [];
  upload_document.map((item, i) => {
    data.push({ id: uuidv4(), image: "", document_name: "" });
    return "";
  });

  const yearly = () => {
    setFieldChange(true)
  }
  const paperonly = () => {
    setFieldChange(false)
  }

  return (
    <form>
      <div className="flex justify-between my-3">
        <p className="text-primary-blue font-Calistoga text-lg underline">
          1. Business Name & Other Details
        </p>
      </div>

      {/* company name and other details */}
      <BusinessSearchNDetails setCmpId={setCmpId} />




      <div className="flex flex-col md:flex-row border-primary-blue text-primary-red border-2 border-t-0 p-1 font-Laila items-center gap-2 text-base font-bold sm:text-base">

        <label htmlFor=""> कम्पनीको वार्षिक विवरणको प्रकार :</label>
        <div onClick={yearly} className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
          <label htmlFor="yearly">
            अध्यावधिक पेपर सहितको कम्पनीको वार्षिक विवरण{" "}
          </label>
          <input type="radio" name="radio-btn" id="yearly" />
        </div>
        <div onClick={paperonly} className="border-primary-blue bg-primary-red flex items-center justify-center gap-1 rounded-full border p-1 text-white">
          <label htmlFor="online">
            {" "}
            Online बाट निकालेको Paper मात्रको वार्षिक विवरण
          </label>
          <input type="radio" name="radio-btn" id="online" />
        </div>
      </div>


      {
        fieldChange ? <><div className="border-2 bg-pink-100 border-primary-blue mt-3">
          <p className="text-primary-blue mt-0 text-lg font-semibold font-Laila leading-10 text-center">
            शेयर सदस्यहरुको संख्याको आधारमा अध्यावधिक सहितको वार्षिक विवरण पेश
            गर्दा तपाईको जम्मा लाग्ने रकम <span className="text-red-400"> रु.१५,०००।– </span> मात्र
          </p>
        </div></> : <> <div className="border-2 bg-pink-100 border-primary-blue mt-3">
          <p className="text-primary-blue mt-0 text-lg font-semibold font-Laila leading-10 text-center">
            शेयर सदस्यहरुको संख्याको आधारमा अध्यावधिक सहितको वार्षिक विवरण पेश
            गर्दा तपाईको जम्मा लाग्ने रकम <span className="text-red-400"> रु.५,०००।–</span> मात्र
          </p>
        </div></>

      }




      {/* upload documents open */}
      <div className="text-primary-blue font-Calistoga text-lg underline my-4">
        2. Upload Document
        <span className="text-primary-blue font-Laila underline">
          (३ महिने विवरण पेश गर्नको लागि आवश्यक पर्ने निम्न कागजपत्रहरु Upload
          गर्नुहोस ।)
        </span>
      </div>

      <Documents
        documents_data={upload_document}
        initialState={data}
        setDocument={setDocsOutput}
      />
      <div className="text-primary-blue font-Calistoga text-lg my-5 mb-6 underline">
        3. Working Branch
        <span className="text-primary-blue font-Laila underline mx-2 ">
          (तपाईले दर्ता गर्न खोज्नुभएको कम्पनी रहने ठेगाना नजिक हाम्रो कुन शाखा नजिक पर्छ छनोट गर्नुहोस् ।)
        </span>
      </div>
      <FormBranch register={register} name={"working_branch"} />
      <FormButtom />
      
      <NewFormPayment
        handleSubmit={handleSubmit} handleClick={handleClick}
        setUploadProof={setUploadProof}
      />
    </form>
  );
};

export default OldAnnualForm;
